import { createSlice } from "@reduxjs/toolkit";
import { ALL_SELECTION } from "utils/constants";
import { defaultStatus } from "utils/constants/container-processing/ContainerAuditConstants";

const initialSearchValues = {
  auditId: "",
  reqBy: ALL_SELECTION,
  auditType: ALL_SELECTION,
  auditStatus: defaultStatus,
  customer: null,
  auditDate: "",
  auditTo: "",
  dueDate: "",
  dueDateTo: "",
  exceptionsOnly: false
};
const initialAuthValues = {
  branch: "",
  customer: "",
  personnel: "",
  authNumber: "",
  challengeQuestion: "",
  challengeResponse: ""
};
const containerAuditSearchSlice = createSlice({
  name: "containerAuditSearch",
  initialState: {
    searchFormValues: initialSearchValues,
    authFormValues: initialAuthValues,
    searchResults: [],
    isLoading: false,
    throwError: false,
    throwErrorMsg: "",
    isAuthenticated: false,
    throwWarning: false,
    throwWarningMsg: "",
    authCustomers: []
  },
  reducers: {
    fetchDataRequest(state) {
      state.isLoading = true;
      state.throwError = null;
    },
    fetchDataSuccess(state, action) {
      state.isLoading = false;
      state.searchResults = action.payload;
    },
    fetchDataFailure(state, action) {
      state.isLoading = false;
      state.throwError = true;
      state.throwErrorMsg = action.payload;
    },

    updateSearchFormValues(state, action) {
      state.searchFormValues = { ...state.searchFormValues, ...action.payload };
    },

    updateAuthFormValues(state, action) {
      state.authFormValues = { ...state.authFormValues, ...action.payload };
    },
    resetForm(state) {
      state.searchFormValues = initialSearchValues;
      state.searchResults = [];
      state.isLoading = false;
      state.throwError = false;
      state.throwErrorMsg = "";
    },
    resetAuthForm(state) {
      state.authFormValues = initialAuthValues;
      state.searchResults = [];
      state.isLoading = false;
      state.throwError = false;
      state.throwErrorMsg = "";
    },
    setSearchResults(state, action) {
      state.searchResults = action.payload;
      state.throwError = false;
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setError(state, action) {
      state.throwError = true;
      state.throwErrorMsg = action.payload;
    },
    setWarning(state, action) {
      state.throwWarning = true;
      state.throwWarningMsg = action.payload;
    },
    clearError(state) {
      state.throwError = false;
      state.throwErrorMsg = "";
    },
    clearWarning(state) {
      state.throwWarning = false;
      state.throwWarningMsg = "";
    },
    updateContainerAuthentication(state, action) {
      state.isAuthenticated = action.payload;
    },
    setAuthCustomers(state, action) {
      state.authCustomers = action.payload;
    }
  }
});

export const {
  updateSearchFormValues,
  resetForm,
  setSearchResults,
  setLoading,
  setError,
  clearError,
  fetchDataRequest,
  fetchDataSuccess,
  fetchDataFailure,
  updateAuthFormValues,
  resetAuthForm,
  updateContainerAuthentication,
  setWarning,
  clearWarning,
  setAuthCustomers
} = containerAuditSearchSlice.actions;

export default containerAuditSearchSlice.reducer;
